import { Grid } from '@material-ui/core';
import React from 'react';
import moment from 'moment';
import CalendarEvent from './CalendarEvent';
import CalendarHeader from './CalendarHeader';
import CalendarSidebarHours from './CalendarSidebarHours';
import CalendarGrid from './CalendarGrid';

import { grabMinimumStartAndEndHour } from '../../../calendarHelpers';
import { CALENDAR_EVENT_GAP } from '..';

const CalendarBody = ({
    bookings,
    paddingHoursBefore,
    paddingHoursAfter,
    cellHeight,
    startDate,
    weekDays,
    onEventClick
}) => {
    const hours = grabMinimumStartAndEndHour(bookings, paddingHoursBefore, paddingHoursAfter);

    // allow agents to book all Vendors into the past even if they are not the client, we show warning in this case
    const hawaiiNow = moment(
        moment()
            .tz('Pacific/Honolulu')
            .startOf('day')
            .format('YYYY-MM-DD')
    );

    const hightlightIdx = Math.ceil(hawaiiNow.diff(startDate, 'days', true));

    return (
        <Grid container item justifyContent="space-around" xs={12}>
            <CalendarSidebarHours
                startHour={hours[0]}
                endHour={hours[1]}
                cellHeight={cellHeight + CALENDAR_EVENT_GAP}
            />
            <Grid container item xs={11} alignContent="flex-start">
                <CalendarHeader
                    weekDays={weekDays}
                    cellHeight={cellHeight + CALENDAR_EVENT_GAP}
                    startDate={startDate.format('YYYY-MM-DD')}
                />
                <Grid
                    container
                    item
                    xs={12}
                    style={{
                        position: 'relative'
                    }}
                >
                    <CalendarGrid
                        startHour={hours[0]}
                        endHour={hours[1]}
                        weekDays={weekDays}
                        cellHeight={cellHeight + CALENDAR_EVENT_GAP}
                        hightlightIdx={hightlightIdx}
                    />
                    {bookings.map((day, dayIdx) =>
                        day.map((event, eventIdx) => {
                            return (
                                <CalendarEvent
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={`${dayIdx}-${eventIdx}`}
                                    hours={hours}
                                    event={event}
                                    eventIdx={eventIdx}
                                    weekDays={weekDays}
                                    cellHeight={cellHeight - CALENDAR_EVENT_GAP}
                                    onEventClick={onEventClick}
                                />
                            );
                        })
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default CalendarBody;
